import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const MovementYearOnYearPage = lazy(() => import('./MovementYearOnYearRenewPage'));
const path = 'reports/movement-yoy-renew';
const MovementYearOnYearRoute: FuseRouteItemType = {
	path: path,
	element: <MovementYearOnYearPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Year on Year Movement',
					helpName: 'Year On Year Movement Renew',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default MovementYearOnYearRoute;
